import { render, staticRenderFns } from "./FormChapter.vue?vue&type=template&id=3bb98268&scoped=true"
import script from "./FormChapter.vue?vue&type=script&lang=ts"
export * from "./FormChapter.vue?vue&type=script&lang=ts"
import style0 from "./FormChapter.vue?vue&type=style&index=0&id=3bb98268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb98268",
  null
  
)

export default component.exports